module.exports = __webpack_public_path__ + "img/20200414142651TIM截图20200414142427.fc77a605.png";